<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    id="app"
    class="app"
  >
    <outer-navigation v-if="isOuterNavigationShow" />
    <template v-if="isBrowserSupport && isWebGlSupport">
      <keep-alive :exclude="['conference', 'login']">
        <router-view />
      </keep-alive>
    </template>
    <template v-else>
      <div class="full-center error-wrapper">
        <div v-if="!isBrowserSupport">
          <figure class="error-wrapper-container">
            <img
              :src="noSupportedImage"
              alt="browser no support"
            >
            <div v-html="$t('browserNoSupport')" />
          </figure>
        </div>
        <div v-else-if="!isWebGlSupport">
          <figure class="error-wrapper-container">
            <img
              :src="noSupportedImage"
              alt="webgl no support"
            >
            <div v-html="$t('webGlNoSupport')" />
          </figure>
        </div>
      </div>
    </template>
    <portal-target
      name="modal"
      multiple
    />
  </div>
</template>

<script>
import * as i18nHelper from './i18n/i18n-helper'
import OuterNavigation from '@/components/OuterNavigation'
import { cesNavigationConfig } from '~js/constants'
export default {
  name: 'App',
  components: {
    OuterNavigation
  },
  data () {
    return {
      isBrowserSupport: false,
      isWebGlSupport: false,
      noSupportedImage: require('./assets/images/error.png')
    }
  },
  computed: {
    isOuterNavigationShow () {
      return this.$store.getters.user.group && this.$store.getters.user.group.objectId === cesNavigationConfig.storeId
    }
  },
  beforeMount () {
    // Set Language
    const lang = i18nHelper.getBrowserLang()
    const locale = i18nHelper.getLocale(lang)
    this.$i18n.locale = locale
    this.$moment.locale(locale)
    document.querySelector('html').setAttribute('lang', locale)

    // Fix the ontouch* APIs default to disabled on desktop issue.
    // https://www.chromestatus.com/feature/4764225348042752
    navigator.pointerEnabled = navigator.maxTouchPoints > 0 // Edge 17 touch support workaround
    document.documentElement.ontouchstart = navigator.maxTouchPoints > 0 // Chrome 70 touch support workaround
  },

  mounted () {
    if (!Function('/*@cc_on return document.documentMode===10@*/ ')()) { // eslint-disable-line
      // if (!(window.ActiveXObject) && 'ActiveXObject' in window) {
      this.isBrowserSupport = true
    }

    const canvas = document.createElement('canvas')
    // Get WebGLRenderingContext from canvas element.
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
    // Report the result.
    if (gl && gl instanceof WebGLRenderingContext) { // eslint-disable-line
      this.isWebGlSupport = true
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/common/main'

.app {
  display: flex
  flex-direction: column
  height: 100%
}

.error-wrapper {
  background-color: #f1f8fc
  pointer-events: auto

  .error-wrapper-container {
    @extend .flex-center-column
    text-align: center

    img {
      margin-bottom: 20px
    }

    &, p, h3 {
      color: $black
      text-shadow: none
    }

    a {
      color: $black
      text-decoration: none
      display: inline-block
      padding: 0 3px
      text-shadow: none

      &:hover {
        text-decoration: underline
      }
    }

    h3 {
      font-size: 18px
      letter-spacing: -.4px
    }

    p, a {
      font-size: 14px
      letter-spacing: -.3px
    }

    h3, p, a {
      margin-top: 7px
    }

    h3 {
      font-size: 18px
      letter-spacing: -.4px
    }

    p, a {
      font-size: 14px
      letter-spacing: -.3px
    }

    h3, p, a {
      margin-top: 7px
    }
  }
}
</style>
